<div class="headline-text">
  <h1>{{ headline }}</h1>
  <span class="muted" [innerHTML]="text"></span>
</div>
